import type { CycleType } from "@src/packages/cycles/hooks/useCycles";

export type FrozenSpecimenTargetType = "semen" | "oocyte" | "embryo";

const FROZEN_SPECIMEN_TREATMENT_TARGETS: Readonly<
  Record<FrozenSpecimenTargetType, readonly CycleType[]>
> = {
  semen: ["iui", "ivf", "icsi"],
  oocyte: ["ivf", "icsi"],
  embryo: ["fet"],
};

/**
 * Frozen material narrows the treatment choices to coordination targets that
 * can use that material. The target is not a clinical recommendation.
 */
export function getFrozenSpecimenTreatmentTargets(
  type: FrozenSpecimenTargetType,
): readonly CycleType[] {
  return FROZEN_SPECIMEN_TREATMENT_TARGETS[type];
}

/**
 * Embryos and oocytes keep their existing sensible defaults. Semen stays
 * unselected because it may be coordinated with IUI, IVF, or ICSI.
 */
export function getFrozenSpecimenInitialTreatment(
  type: FrozenSpecimenTargetType,
): CycleType | null {
  if (type === "embryo") return "fet";
  if (type === "oocyte") return "ivf";
  return null;
}

export function frozenSpecimenTreatmentMatches(
  specimenType: FrozenSpecimenTargetType,
  treatmentType: CycleType,
): boolean {
  return getFrozenSpecimenTreatmentTargets(specimenType).includes(
    treatmentType,
  );
}
